import { inject, isDevMode } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { map } from 'rxjs/operators';

import { Store } from '@ngrx/store';
import { accountFeature } from 'app/travomate/store/account/account.state';

export const TravomateUserRouteAccessService: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const store = inject(Store);
  const router = inject(Router);
  return store.select(accountFeature.selectAuthorities).pipe(
    map(userAuthorities => {
      const authorities = next.data['authorities'];

      if (!authorities) {
        return true;
      }

      const hasAuthority = userAuthorities.some((authority: string) => authorities.includes(authority));

      if (hasAuthority) {
        return true;
      }

      if (isDevMode()) {
        console.error('User does not have any of the required authorities:', next, authorities, userAuthorities);
      }

      router.navigate(['accessdenied']);
      return false;
    }),
  );
};
